import { UseFormReturn } from "react-hook-form"
import { EventFormData } from "@/types/events"
import { Card } from "@/components/ui/card"
import { EventDateTime } from "../form/EventDateTime"

interface EventDetailsFormProps {
  form: UseFormReturn<EventFormData>
  format?: string
  onTimezoneChange?: (timezone: string) => void
}

export function EventDetailsForm({
  form,
  format,
  onTimezoneChange
}: EventDetailsFormProps) {
  const { register, formState: { errors }, setValue, watch } = form
  const isPhysicalFormat = ["In-Office", "Kiosk", "Hybrid"].includes(format || "")

  return (
    <div className="space-y-6">
      <Card className="p-6">
        <h3 className="text-lg font-medium mb-4">Date & Time</h3>
        <EventDateTime
          register={register}
          errors={errors}
          setValue={setValue}
          watch={watch}
          onTimezoneChange={onTimezoneChange}
        />
      </Card>

      {/* Location field is now handled in the AnonCheckout component */}
    </div>
  )
}